import './Main.scss'
import React, { useState } from 'react'
import SwipeableViews from 'react-swipeable-views'
import { useTheme, useMediaQuery } from '@material-ui/core'
import { ButtonArrow } from '@svort/component'

import { Translated } from '../../utils/translated'
import { isSafariBrowser } from '../../utils/utils'
import auth from './images/auth.png'
import onboarding from './images/onboarding.png'
import features from './images/features.png'

const Main = (props) => {

    const theme = useTheme();
    const [page, setPage] = useState(0);
    const [hover, setHover] = useState(false);

    const isMobile = useMediaQuery('(max-width:600px)');
    const isSafari = isSafariBrowser();

    const navs = [
        (<div key={0} className='nav-element'
            onClick={() => !isMobile && props.history.push('/select-auth')}
            onMouseEnter={() => !isMobile && setHover(1)}
            onMouseLeave={() => !isMobile && setHover(false)}>
            <img src={auth} alt='loading...' />
            <div className='title'>
                <p>{<Translated id='app.main.authentication' />}</p>
                <div className='badge'>
                    <Translated id='app.main.use-case' />
                </div>
            </div>
            <div className='description'>
                <Translated id='app.main.authentication-desc' />
            </div>
            <ButtonArrow
                text={<Translated id='app.button.test' />}
                onClick={() => isMobile && props.history.push('/select-auth')}
                isHover={hover === 1} />
        </div>),
        (<div key={1} className='nav-element'
            onClick={() => !isMobile && props.history.push('/select-onboarding')}
            onMouseEnter={() => !isMobile && setHover(2)}
            onMouseLeave={() => !isMobile && setHover(false)}>
            <img src={onboarding} alt='loading...' />
            <div className='title'>
                <p><Translated id='app.main.onboarding' /></p>
                <div className='badge'>
                    <Translated id='app.main.use-case' />
                </div>
            </div>
            <div className='description'>
                <p><Translated id='app.main.onboarding-desc' /></p>
            </div>
            <ButtonArrow
                text={<Translated id='app.button.test' />}
                onClick={() => isMobile && props.history.push('/select-onboarding')}
                isHover={hover === 2} />
        </div>),
        (<div key={2} className='nav-element'
            onClick={() => !isMobile && props.history.push('/feature')}
            onMouseEnter={() => !isMobile && setHover(3)}
            onMouseLeave={() => !isMobile && setHover(false)}>
            <img src={features} alt='loading...' />
            <div className='title'>
                <p><Translated id='app.main.features' /></p>
                <div className='badge'>
                    <Translated id='app.main.features-count' />
                </div>
            </div>
            <div className='description'>
                <p><Translated id='app.main.features-desc' values={{ b: 'b' }} /></p>
            </div>
            <ButtonArrow
                text={<Translated id='app.button.more' />}
                onClick={() => isMobile && props.history.push('/feature')}
                isHover={hover === 3} />
        </div>)];

    return (
        <div className='main'>
            <div className='wrapper'>
                <div className='header-big'>
                    <p><Translated id='app.main.title' /></p><br />
                </div>

                {!isMobile
                    ? <div className={`nav${!isSafari ? ' zoom' : ''}`}>
                        {navs.map(x => x)}
                    </div>
                    : <SwipeableViews
                        className='nav'
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={page}
                        onChangeIndex={(step) => setPage(step)}
                        enableMouseEvents>
                        {navs}
                    </SwipeableViews>}

                <div className='pagination'>
                    <div onClick={() => setPage(0)} style={{ opacity: page === 0 ? 1 : 0.3 }}></div>
                    <div onClick={() => setPage(1)} style={{ opacity: page === 1 ? 1 : 0.3 }}></div>
                    <div onClick={() => setPage(2)} style={{ opacity: page === 2 ? 1 : 0.3 }}></div>
                </div>

                <div className='privacy'>
                    <Translated id='app.main.terms-of-use' values={{
                        disclaimer: <span className='link' onClick={() => window.location.href = 'https://demo.svort.me/privacy/Disclaimer_and_License_Agreement_for_Svort_system_software_and_its.pdf'}>
                            <Translated id='app.main.disclaimer' />
                        </span>,
                        privacy: <span className='link' onClick={() => window.location.href = 'https://demo.svort.me/privacy/privacy%20policy%20SVORT%20(site%20and%20SDK).pdf'}>
                            <Translated id='app.main.privacy' />
                        </span>
                    }} />
                </div>
            </div>
        </div>
    )
}

export default Main
